require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-chatbot-in-the-housing-sector.json") })
        }
      }, "path---blog-chatbot-in-the-housing-sector");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-chatbot-in-the-housing-sector!./.cache/json/blog-chatbot-in-the-housing-sector.json
// module id = 812
// module chunks = 231608221292675